import alabama from '../stateContent/alabama.json';
import alaska from '../stateContent/alaska.json';
import arizona from '../stateContent/arizona.json';
import arkansas from '../stateContent/arkansas.json';
import california from '../stateContent/california.json';
import colorado from '../stateContent/colorado.json';
import connecticut from '../stateContent/connecticut.json';
import dc from '../stateContent/dc.json';
import delaware from '../stateContent/delaware.json';
import florida from '../stateContent/florida.json';
import georgia from '../stateContent/georgia.json';
import hawaii from '../stateContent/hawaii.json';
import idaho from '../stateContent/idaho.json';
import illinois from '../stateContent/illinois.json';
import indiana from '../stateContent/indiana.json';
import iowa from '../stateContent/iowa.json';
import kansas from '../stateContent/kansas.json';
import kentucky from '../stateContent/kentucky.json';
import louisiana from '../stateContent/louisiana.json';
import maine from '../stateContent/maine.json';
import maryland from '../stateContent/maryland.json';
import massachusetts from '../stateContent/massachusetts.json';
import michigan from '../stateContent/michigan.json';
import minnesota from '../stateContent/minnesota.json';
import mississippi from '../stateContent/mississippi.json';
import missouri from '../stateContent/missouri.json';
import montana from '../stateContent/montana.json';
import nebraska from '../stateContent/nebraska.json';
import nevada from '../stateContent/nevada.json';
import newHampshire from '../stateContent/new_hampshire.json';
import newJersey from '../stateContent/new_jersey.json';
import newMexico from '../stateContent/new_mexico.json';
import newYork from '../stateContent/new_york.json';
import northCarolina from '../stateContent/north_carolina.json';
import northDakota from '../stateContent/north_dakota.json';
import ohio from '../stateContent/ohio.json';
import oklahoma from '../stateContent/oklahoma.json';
import oregon from '../stateContent/oregon.json';
import pennsylvania from '../stateContent/pennsylvania.json';
import rhodeIsland from '../stateContent/rhode_island.json';
import southCarolina from '../stateContent/south_carolina.json';
import southDakota from '../stateContent/south_dakota.json';
import tennessee from '../stateContent/tennessee.json';
import texas from '../stateContent/texas.json';
import utah from '../stateContent/utah.json';
import vermont from '../stateContent/vermont.json';
import virginia from '../stateContent/virginia.json';
import washington from '../stateContent/washington.json';
import westVirginia from '../stateContent/west_virginia.json';
import wisconsin from '../stateContent/wisconsin.json';
import wyoming from '../stateContent/wyoming.json';

const stateData = [
    alabama,
    alaska,
    arizona,
    arkansas,
    california,
    colorado,
    connecticut,
    dc,
    delaware,
    florida,
    georgia,
    hawaii,
    idaho,
    illinois,
    indiana,
    iowa,
    kansas,
    kentucky,
    louisiana,
    maine,
    maryland,
    massachusetts,
    michigan,
    minnesota,
    mississippi,
    missouri,
    montana,
    nebraska,
    nevada,
    newHampshire,
    newJersey,
    newMexico,
    newYork,
    northCarolina,
    northDakota,
    ohio,
    oklahoma,
    oregon,
    pennsylvania,
    rhodeIsland,
    southCarolina,
    southDakota,
    tennessee,
    texas,
    utah,
    vermont,
    virginia,
    washington,
    westVirginia,
    wisconsin,
    wyoming,
];

export default stateData;
